export function yieldToMain() {
  // @ts-ignore
  if ('scheduler' in window && 'yield' in scheduler) {
    // @ts-ignore
    return scheduler.yield();
  }

  // Fall back to yielding with setTimeout.
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}
